module.exports = __webpack_public_path__ + "img/travel_1.cbaecba3.svg";